export class Legend {
  /*----- required values ------*/
  name: string;
  href: string;
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/models/legend.model.ts